import {
  Button,
  Checkbox,
  DialogActions,
  DialogContent,
  FormControlLabel,
  Paper,
  Stack,
  Typography
} from '@mui/material';
import { TranslatedText } from '@ianesthesie-kit/core';
import React, { useState } from 'react';
import {
  DialogSecondaryAction,
  DialogTitleWithCloseAction,
  useDialogPromise
} from '@ianesthesie-kit/redux';
import { MedicalDocumentService } from '@/modules/surgicalEvent';

export const DeleteMediumWarningDialog = () => {
  const { closeAndResolve } = useDialogPromise();
  const [muted, setMuted] = useState(false);

  const onCancel = () => {
    closeAndResolve(false);
  };

  const onProceed = () => {
    if (muted) {
      MedicalDocumentService.muteDeleteWarning();
    }
    closeAndResolve(true);
  };

  return (
    <Paper sx={{ p: 0, maxWidth: 600, minWidth: { xs: 'unset', md: 600 } }}>
      <DialogTitleWithCloseAction onClose={onCancel}>
        <TranslatedText id="doctor-dashboard.triagesDocumentDeleteDialog.title" />
      </DialogTitleWithCloseAction>
      <DialogContent>
        <Stack gap={3}>
          <Typography paragraph variant="body1">
            <TranslatedText id="doctor-dashboard.triagesDocumentDeleteDialog.body" />
          </Typography>
          <FormControlLabel
            control={
              <Checkbox checked={muted} onChange={(e, v) => setMuted(v)} />
            }
            label={
              <Typography variant="body2">
                <TranslatedText id="doctor-dashboard.undoableActionWarning.mute" />
              </Typography>
            }
          />
        </Stack>
      </DialogContent>
      <DialogActions>
        <DialogSecondaryAction onClick={onCancel}>
          <TranslatedText id="app.cancel" />
        </DialogSecondaryAction>
        <Button variant="contained" color="error" onClick={onProceed}>
          <TranslatedText id="app.delete" />
        </Button>
      </DialogActions>
    </Paper>
  );
};
